import React from "react";

function InternalNotesIcon() {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2867_5204)">
        <g clipPath="url(#clip1_2867_5204)">
          <path
            d="M4.63647 0.772461V3.86337M7.72738 0.772461V3.86337M10.8183 0.772461V3.86337"
            stroke="#424242"
            strokeWidth="1.31364"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.3636 2.31836H3.09086C2.23733 2.31836 1.54541 3.01028 1.54541 3.86381V14.682C1.54541 15.5355 2.23733 16.2274 3.09086 16.2274H12.3636C13.2171 16.2274 13.909 15.5355 13.909 14.682V3.86381C13.909 3.01028 13.2171 2.31836 12.3636 2.31836Z"
            stroke="#424242"
            strokeWidth="1.31364"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.63647 6.9541H9.27284M4.63647 10.045H10.8183M4.63647 13.1359H8.50011"
            stroke="#424242"
            strokeWidth="1.31364"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2867_5204">
          <rect width="16" height="17" fill="white" />
        </clipPath>
        <clipPath id="clip1_2867_5204">
          <rect width="14.6818" height="17" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default InternalNotesIcon;
